// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2gtw0","list":"BalanceDue_list__1dmcW","listRow":"BalanceDue_listRow__3_dxd","total":"BalanceDue_total__dNWDU"};